import { api } from '~/services/api';

const MODULE_URL = 'measurement-report';

interface Filter {
  units: string[];
  startDate: Date;
  endDate: Date;
}

const mapQueryParams = (params: Filter) => {
  return {
    unitIds: params.units,
    startDate: params.startDate,
    endDate: params.endDate,
  };
};

export default class MeasurementReportService {
  static async membersLogHoursDownloadReportCSV(
    ecosystemId: string,
    params: Filter,
  ) {
    const queryParams = mapQueryParams(params);
    return await api.get(
      `${MODULE_URL}/members-log-hours/download/csv/${ecosystemId}`,
      {
        params: queryParams,
      },
    );
  }

  static async membersLogHoursDownloadReportXLSX(
    ecosystemId: string,
    params: Filter,
  ) {
    const queryParams = mapQueryParams(params);
    return await api.get(
      `${MODULE_URL}/members-log-hours/download/xlsx/${ecosystemId}`,
      {
        params: queryParams,
      },
    );
  }
}
